/* ============================================================
   COOL CARS CLUB — Landing de lançamento (página de senha)
   JS extraído de ccc.html — carregado via asset ccc-landing.js
   ============================================================ */
  (function () {
    var root = document.getElementById('ccc-count');
    if (!root) return;
    var target = new Date(root.getAttribute('data-target')).getTime();
    if (isNaN(target)) return;
    var els = {
      d: root.querySelector('[data-unit="d"]'),
      h: root.querySelector('[data-unit="h"]'),
      m: root.querySelector('[data-unit="m"]'),
      s: root.querySelector('[data-unit="s"]')
    };
    function pad(n) { return String(n).padStart(2, '0'); }
    function tick() {
      var diff = target - Date.now();
      if (diff <= 0) {
        els.d.textContent = els.h.textContent = els.m.textContent = els.s.textContent = '00';
        return;
      }
      els.d.textContent = pad(Math.floor(diff / 86400000));
      els.h.textContent = pad(Math.floor(diff / 3600000) % 24);
      els.m.textContent = pad(Math.floor(diff / 60000) % 60);
      els.s.textContent = pad(Math.floor(diff / 1000) % 60);
      setTimeout(tick, 1000);
    }
    tick();
  })();
  /* frases rotativas com efeito de embaralhamento (scramble) */
  (function () {
    var el = document.getElementById('ccc-fine');
    if (!el) return;
    var phrases = ['acesso antecipado', 'conteudo exclusivo', 'bastidores'];
    var chars = 'abcdefghijklmnopqrstuvwxyz#*+-/<>';
    var idx = 0;
    var frame = null;
    function scrambleTo(to) {
      var from = el.textContent;
      var len = Math.max(from.length, to.length);
      var queue = [];
      for (var i = 0; i < len; i++) {
        var start = Math.floor(Math.random() * 18);
        var end = start + 8 + Math.floor(Math.random() * 14);
        queue.push({ from: from[i] || '', to: to[i] || '', start: start, end: end, char: '' });
      }
      var f = 0;
      if (frame) cancelAnimationFrame(frame);
      (function update() {
        var out = '';
        var done = 0;
        for (var i = 0; i < queue.length; i++) {
          var q = queue[i];
          if (f >= q.end) {
            done++;
            out += q.to;
          } else if (f >= q.start) {
            if (!q.char || Math.random() < 0.28) {
              q.char = chars[Math.floor(Math.random() * chars.length)];
            }
            out += '<span class="ccc-scramble-char">' + q.char + '</span>';
          } else {
            out += q.from;
          }
        }
        el.innerHTML = out;
        if (done < queue.length) {
          f++;
          frame = requestAnimationFrame(update);
        }
      })();
    }
    setInterval(function () {
      idx = (idx + 1) % phrases.length;
      scrambleTo(phrases[idx]);
    }, 3400);
  })();
  /* comparador antes/depois do bloco 2 */
  (function () {
    var frame = document.getElementById('ccc-ba-frame');
    if (!frame) return;
    var before = document.getElementById('ccc-ba-before');
    var after = document.getElementById('ccc-ba-after');
    var options = document.getElementById('ccc-ba-options');
    var buttons = Array.prototype.slice.call(options.querySelectorAll('button'));
    var mobileQuery = window.matchMedia('(max-width: 749px)');
    var currentBtn = null;
    function basePos() { return mobileQuery.matches ? 65 : 60; }
    function pick(btn, attr) {
      var desktop = btn.getAttribute('data-' + attr);
      var mobile = btn.getAttribute('data-' + attr + '-mobile');
      if (mobileQuery.matches && mobile && mobile !== '#') return mobile;
      return desktop;
    }
    function src(url, label) {
      if (!url || url === '#') {
        var size = mobileQuery.matches ? '900x1100' : '1200x1000';
        return 'https://placehold.co/' + size + '/111111/444444.png?text=' + encodeURIComponent(label);
      }
      return url;
    }
    function preloadAll() {
      buttons.forEach(function (b) {
        ['before', 'after'].forEach(function (attr) {
          var url = pick(b, attr);
          if (url && url !== '#') {
            var im = new Image();
            im.src = url;
          }
        });
      });
    }
    function fitFrame() {
      if (before.naturalWidth && before.naturalHeight) {
        frame.style.setProperty('aspect-ratio', before.naturalWidth + ' / ' + before.naturalHeight, 'important');
      }
    }
    before.addEventListener('load', fitFrame);
    function select(btn) {
      currentBtn = btn;
      buttons.forEach(function (b) { b.classList.toggle('is-active', b === btn); });
      var name = btn.textContent.trim();
      before.src = src(pick(btn, 'before'), name + ' -- NPC');
      after.src = src(pick(btn, 'after'), name + ' -- COOL');
      fitFrame();
      setPos(basePos());
    }
    buttons.forEach(function (b) {
      b.addEventListener('click', function () { select(b); });
    });
    var onBreakpoint = function () {
      if (currentBtn) select(currentBtn);
      preloadAll();
    };
    if (mobileQuery.addEventListener) { mobileQuery.addEventListener('change', onBreakpoint); }
    else if (mobileQuery.addListener) { mobileQuery.addListener(onBreakpoint); }
    function limits() {
      return mobileQuery.matches ? { min: 4, max: 96 } : { min: 23, max: 77 };
    }
    function setPos(pct) {
      var l = limits();
      pct = Math.min(l.max, Math.max(l.min, pct));
      frame.style.setProperty('--pos', pct + '%');
    }
    var dragging = false;
    var interacted = false;
    function posFromEvent(e) {
      var r = frame.getBoundingClientRect();
      var x = (e.touches ? e.touches[0].clientX : e.clientX) - r.left;
      setPos((x / r.width) * 100);
    }
    frame.addEventListener('pointerdown', function (e) {
      dragging = true;
      interacted = true;
      frame.classList.remove('is-nudging');
      frame.setPointerCapture && frame.setPointerCapture(e.pointerId);
      posFromEvent(e);
    });
    frame.addEventListener('pointermove', function (e) {
      if (dragging) posFromEvent(e);
    });
    frame.addEventListener('pointerup', function () { dragging = false; });
    frame.addEventListener('pointercancel', function () { dragging = false; });
    function nudge() {
      if (interacted || dragging) return;
      var base = basePos();
      frame.classList.add('is-nudging');
      setPos(base + 4);
      setTimeout(function () { if (!interacted) setPos(base - 3); }, 500);
      setTimeout(function () { if (!interacted) setPos(base); }, 1000);
      setTimeout(function () { frame.classList.remove('is-nudging'); }, 1550);
    }
    setTimeout(nudge, 1800);
    setInterval(nudge, 5000);
    select(buttons[0]);
    preloadAll();
  })();
  /* parallax no video de fundo do BUILT NOT BOUGHT */
  (function () {
    var vstack = document.getElementById('ccc-built-vstack');
    if (!vstack) return;
    var wrap = document.getElementById('ccc-built-bg');
    /* escolhe src mobile ou desktop e inicia os vídeos */
    var isMobileLoad = window.innerWidth <= 749;
    Array.prototype.forEach.call(vstack.querySelectorAll('.ccc-built-vitem'), function (v) {
      var src = isMobileLoad
        ? v.getAttribute('data-src-mobile')
        : v.getAttribute('data-src-desktop');
      if (src) { v.src = src; v.load(); }
    });
    var EASE = 0.08;
    var current = 0;
    var targetY = 13;
    var raf = null;
    /* ── FORÇA DO PARALLAX ── altere os valores abaixo (0 = sem efeito, 1 = normal, 2 = dobro) */
    var PARALLAX_STRENGTH_DESKTOP = 0.45;
    var PARALLAX_STRENGTH_MOBILE  = 0.31;
    /* ── OFFSET VERTICAL ── desloca a posição inicial do vídeo em px
       positivo = sobe o vídeo (mostra parte de baixo), negativo = desce (mostra parte de cima) */
    var PARALLAX_OFFSET_DESKTOP = -270;
    var PARALLAX_OFFSET_MOBILE  = -110;
    function computeTarget() {
      var isMobile = window.innerWidth <= 749;
      var PARALLAX_STRENGTH = isMobile ? PARALLAX_STRENGTH_MOBILE : PARALLAX_STRENGTH_DESKTOP;
      var PARALLAX_OFFSET   = isMobile ? PARALLAX_OFFSET_MOBILE   : PARALLAX_OFFSET_DESKTOP;
      var r = wrap.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      /* travel máximo = altura total da stack menos a altura do container */
      var maxTravel = vstack.scrollHeight - wrap.offsetHeight;
      if (maxTravel <= 0) { targetY = 0; return; }
      var p = 1 - (r.top + r.height) / (vh + r.height);
      p = Math.min(1, Math.max(0, p));
      /* PARALLAX_STRENGTH amplifica o movimento; PARALLAX_OFFSET desloca a posição base */
      targetY = Math.min(Math.max(0, p * maxTravel * PARALLAX_STRENGTH + PARALLAX_OFFSET), maxTravel);
    }
    function loop() {
      current += (targetY - current) * EASE;
      if (Math.abs(targetY - current) < 0.3) current = targetY;
      vstack.style.transform = 'translate3d(0, ' + (-current).toFixed(2) + 'px, 0)';
      if (current !== targetY) {
        raf = requestAnimationFrame(loop);
      } else {
        raf = null;
      }
    }
    function onScroll() {
      computeTarget();
      if (!raf) raf = requestAnimationFrame(loop);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    onScroll();
  })();
  /* flip cards — ícone de troca + toggle */
  (function () {
    var cards = document.querySelectorAll('.ccc-flip');
    if (!cards.length) return;
    var hintSVG =
      '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
        '<path d="M17 1l4 4-4 4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
        '<path d="M3 11V9a4 4 0 0 1 4-4h14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
        '<path d="M7 23l-4-4 4-4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
        '<path d="M21 13v2a4 4 0 0 1-4 4H3" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
      '</svg>';
    for (var i = 0; i < cards.length; i++) {
      if (cards[i].querySelector('.ccc-flip__name')) continue;
      var hint = document.createElement('span');
      hint.className = 'ccc-flip__hint';
      hint.innerHTML = hintSVG;
      cards[i].appendChild(hint);
    }
  })();
  /* checklist interativa — Se identifica? */
  (function () {
    var items = document.querySelectorAll('.ccc-check__item');
    var counter = document.getElementById('ccc-check-counter');
    var conclusao = document.getElementById('ccc-check-conclusao');
    if (!items.length) return;
    function update() {
      var checked = 0;
      for (var i = 0; i < items.length; i++) {
        if (items[i].classList.contains('is-checked')) checked++;
      }
      if (counter) {
        counter.textContent = checked === 0 ? 'marque os que se aplicam' : checked + ' / ' + items.length + ' marcados';
        counter.classList.toggle('has-checks', checked > 0);
      }
      if (conclusao) conclusao.classList.toggle('is-active', checked > 0);
    }
    for (var i = 0; i < items.length; i++) {
      (function (item) {
        item.addEventListener('click', function () {
          item.classList.toggle('is-checked');
          update();
        });
      })(items[i]);
    }
    /* animar entrada dos itens ao scroll */
    if ('IntersectionObserver' in window) {
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          var idx = 0;
          for (var k = 0; k < items.length; k++) { if (items[k] === e.target) { idx = k; break; } }
          setTimeout(function () { e.target.classList.add('is-visible'); }, idx * 90);
          obs.unobserve(e.target);
        });
      }, { threshold: 0.15 });
      for (var j = 0; j < items.length; j++) obs.observe(items[j]);
    } else {
      for (var j = 0; j < items.length; j++) items[j].classList.add('is-visible');
    }
    update();
  })();
  /* modal saiba mais / participe */
  (function () {
    var overlay = document.getElementById('ccc-saiba-overlay');
    if (!overlay) return;
    var closeBtn = document.getElementById('ccc-saiba-close');
    var kitImg = document.getElementById('ccc-saiba-kit-img');
    /* esconde a img enquanto src estiver vazio */
    if (kitImg && !kitImg.src) kitImg.style.display = 'none';
    function open() { overlay.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
    function close() { overlay.classList.remove('is-open'); document.body.style.overflow = ''; }
    /* triggers: Saiba mais + Participe (só o <a>, não o botão Ver tudo) */
    var triggers = document.querySelectorAll('.ccc-carousel-promo-link, a.ccc-carousel-bar__link');
    for (var i = 0; i < triggers.length; i++) {
      triggers[i].addEventListener('click', function (e) { e.preventDefault(); open(); });
    }
    if (closeBtn) closeBtn.addEventListener('click', close);
    overlay.addEventListener('click', function (e) { if (e.target === overlay) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  })();
  /* carrossel 3d infinito, ordem aleatoria por visita */
  (function () {
    var stage = document.getElementById('ccc-stage');
    if (!stage) return;
    var cards = Array.prototype.slice.call(stage.children);
    for (var i = cards.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var t = cards[i]; cards[i] = cards[j]; cards[j] = t;
    }
    var n = cards.length;
    var cur = 0;
    function render() {
      for (var i = 0; i < n; i++) {
        var d = ((i - cur) % n + n) % n;
        if (d > n / 2) d -= n;
        var ad = Math.abs(d);
        var c = cards[i];
        c.style.transform =
          'translateX(' + (d * 55) + '%) ' +
          'translateZ(' + (-ad * 160) + 'px) ' +
          'rotateY(' + (d * -8) + 'deg) ' +
          'scale(' + Math.max(0.55, 1 - ad * 0.16) + ')';
        c.style.zIndex = String(100 - ad);
        c.style.opacity = ad > 2.5 ? '0' : '1';
        c.classList.toggle('is-active', d === 0);
      }
    }
    function go(dir) { cur = ((cur + dir) % n + n) % n; render(); }
    document.getElementById('ccc-prev').addEventListener('click', function () { go(-1); });
    document.getElementById('ccc-next').addEventListener('click', function () { go(1); });
    cards.forEach(function (c, i) {
      c.addEventListener('click', function () {
        if (i !== cur) { cur = i; render(); }
      });
    });
    var x0 = null, y0 = null;
    stage.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      var dy = e.changedTouches[0].clientY - y0;
      /* só navega se o movimento for claramente horizontal */
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) go(dx < 0 ? 1 : -1);
      x0 = null; y0 = null;
    }, { passive: true });
    render();
  })();
  /* sistema de likes */
  (function () {
    var WORKER_URL = 'https://votes.midnightcrewstore.workers.dev/';
    var VOTER_KEY = 'ccc_voter_id';
    var VOTES_KEY = 'ccc_votes';
    function getVoterId() {
      var id = localStorage.getItem(VOTER_KEY);
      if (!id) {
        id = 'v-' + Date.now() + '-' + Math.random().toString(36).slice(2, 10);
        localStorage.setItem(VOTER_KEY, id);
      }
      return id;
    }
    function getFingerprint() {
      try {
        var parts = [];
        parts.push(navigator.userAgent || '');
        parts.push(navigator.language || '');
        parts.push(String(screen.width) + 'x' + String(screen.height) + 'x' + String(screen.colorDepth));
        parts.push(String(new Date().getTimezoneOffset()));
        parts.push(String(navigator.hardwareConcurrency || ''));
        parts.push(String(navigator.platform || ''));
        try {
          var canvas = document.createElement('canvas');
          var ctx = canvas.getContext('2d');
          ctx.textBaseline = 'top';
          ctx.font = "14px 'Arial'";
          ctx.fillStyle = '#f60';
          ctx.fillRect(125, 1, 62, 20);
          ctx.fillStyle = '#069';
          ctx.fillText('ccc-fp', 2, 15);
          parts.push(canvas.toDataURL());
        } catch (e) {}
        var str = parts.join('||');
        var hash = 0;
        for (var i = 0; i < str.length; i++) {
          hash = ((hash << 5) - hash) + str.charCodeAt(i);
          hash |= 0;
        }
        return 'fp-' + Math.abs(hash).toString(36);
      } catch (e) {
        return 'fp-unknown';
      }
    }
    function getVotes() {
      try { return JSON.parse(localStorage.getItem(VOTES_KEY) || '{}'); } catch (e) { return {}; }
    }
    function saveVote(carId) {
      var votes = getVotes();
      votes[carId] = true;
      localStorage.setItem(VOTES_KEY, JSON.stringify(votes));
    }
    function setVotes(votesObj) {
      localStorage.setItem(VOTES_KEY, JSON.stringify(votesObj));
    }
    function lockButton(btn) {
      btn.classList.add('is-locked');
      btn.setAttribute('disabled', 'disabled');
    }
    function unlockButton(btn) {
      btn.classList.remove('is-locked');
      btn.removeAttribute('disabled');
    }
    var FIRE_SVG = '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path opacity="0.5" d="M12.8324 21.8013C15.9583 21.1747 20 18.926 20 13.1112C20 7.8196 16.1267 4.29593 13.3415 2.67685C12.7235 2.31757 12 2.79006 12 3.50492V5.3334C12 6.77526 11.3938 9.40711 9.70932 10.5018C8.84932 11.0607 7.92052 10.2242 7.816 9.20388L7.73017 8.36604C7.6304 7.39203 6.63841 6.80075 5.85996 7.3946C4.46147 8.46144 3 10.3296 3 13.1112C3 20.2223 8.28889 22.0001 10.9333 22.0001C11.0871 22.0001 11.2488 21.9955 11.4171 21.9858C11.863 21.9296 11.4171 22.085 12.8324 21.8013Z" fill="currentColor"></path>'
      + '<path d="M8 18.4442C8 21.064 10.1113 21.8742 11.4171 21.9858C11.863 21.9296 11.4171 22.085 12.8324 21.8013C13.871 21.4343 15 20.4922 15 18.4442C15 17.1465 14.1814 16.3459 13.5401 15.9711C13.3439 15.8564 13.1161 16.0008 13.0985 16.2273C13.0429 16.9454 12.3534 17.5174 11.8836 16.9714C11.4685 16.4889 11.2941 15.784 11.2941 15.3331V14.7439C11.2941 14.3887 10.9365 14.1533 10.631 14.3346C9.49507 15.0085 8 16.3949 8 18.4442Z" fill="currentColor"></path>'
      + '</svg>';
    function launchBigFire() {
      var overlay = document.getElementById('ccc-fire-overlay');
      if (!overlay) {
        overlay = document.createElement('div');
        overlay.id = 'ccc-fire-overlay';
        overlay.className = 'ccc-fire-overlay';
        (document.querySelector('.ccc-landing') || document.body).appendChild(overlay);
      }
      var count = 18;
      for (var i = 0; i < count; i++) {
        (function (i) {
          setTimeout(function () {
            var el = document.createElement('div');
            el.className = 'ccc-fire-big';
            el.innerHTML = FIRE_SVG;
            var size = 26 + Math.random() * 46;
            el.style.width = size + 'px';
            el.style.height = size + 'px';
            el.style.left = (Math.random() * 100) + 'vw';
            var duration = 2.6 + Math.random() * 1.8;
            el.style.animationDuration = duration + 's';
            el.style.setProperty('--drift', (Math.round(Math.random() * 160 - 80)) + 'px');
            el.style.setProperty('--rot', (Math.round(Math.random() * 50 - 25)) + 'deg');
            overlay.appendChild(el);
            setTimeout(function () { el.remove(); }, duration * 1000 + 150);
          }, i * 55);
        })(i);
      }
    }
    function sendVote(carId, model) {
      if (!WORKER_URL || WORKER_URL.indexOf('COLE_AQUI') !== -1) return;
      var payload = {
        action: 'vote',
        voter_id: getVoterId(),
        fp: getFingerprint(),
        car_id: carId,
        model: model,
        ts: new Date().toISOString()
      };
      fetch(WORKER_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'text/plain;charset=utf-8' },
        body: JSON.stringify(payload)
      }).catch(function () {});
    }
    var cards = document.querySelectorAll('.ccc-car-card');
    cards.forEach(function (card) {
      var carId = card.getAttribute('data-car-id');
      var btn = card.querySelector('.ccc-car-card__like');
      if (!btn || !carId) return;
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        if (btn.classList.contains('is-locked')) return;
        if (navigator.vibrate) navigator.vibrate(40);
        var modelEl = card.querySelector('.ccc-car-card__model');
        launchBigFire();
        lockButton(btn);
        saveVote(carId);
        sendVote(carId, modelEl ? modelEl.textContent.trim() : carId);
      });
    });
    if (WORKER_URL && WORKER_URL.indexOf('COLE_AQUI') === -1) {
      fetch(WORKER_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'text/plain;charset=utf-8' },
        body: JSON.stringify({ action: 'check', voter_id: getVoterId(), fp: getFingerprint() })
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (!res || !res.voted) return;
          var freshVotes = {};
          res.voted.forEach(function (carId) { freshVotes[carId] = true; });
          setVotes(freshVotes);
          cards.forEach(function (card) {
            var cId = card.getAttribute('data-car-id');
            var btn = card.querySelector('.ccc-car-card__like');
            if (!btn || !cId) return;
            if (freshVotes[cId]) lockButton(btn); else unlockButton(btn);
          });
        })
        .catch(function () {});
    }
    /* LIGHTBOX */
    var lightboxOverlay = document.getElementById('ccc-lightbox-overlay');
    var lightboxImg = document.getElementById('ccc-lightbox-img');
    var lightboxClose = document.getElementById('ccc-lightbox-close');
    function openLightbox(src, alt) {
      if (!lightboxOverlay || !lightboxImg) return;
      lightboxImg.src = src;
      lightboxImg.alt = alt || '';
      lightboxOverlay.classList.add('is-open');
    }
    function closeLightbox() {
      if (!lightboxOverlay) return;
      lightboxOverlay.classList.remove('is-open');
      lightboxImg.src = '';
    }
    if (lightboxOverlay) {
      lightboxOverlay.addEventListener('click', closeLightbox);
      if (lightboxClose) lightboxClose.addEventListener('click', function (e) { e.stopPropagation(); closeLightbox(); });
    }
    cards.forEach(function (card) {
      var photo = card.querySelector('.ccc-car-card__photo');
      if (!photo) return;
      photo.addEventListener('click', function (e) {
        if (!card.classList.contains('is-active')) return;
        e.stopPropagation();
        var img = photo.querySelector('img');
        if (img) openLightbox(img.getAttribute('src'), img.getAttribute('alt'));
      });
    });
    /* MODAL "VER TUDO" */
    var viewallOpenBtn = document.getElementById('ccc-viewall-open');
    var viewallOverlay = document.getElementById('ccc-viewall-overlay');
    var viewallCloseBtn = document.getElementById('ccc-viewall-close');
    var viewallSearch = document.getElementById('ccc-viewall-search');
    var viewallSortBtn = document.getElementById('ccc-viewall-sort-btn');
    var viewallSortMenu = document.getElementById('ccc-viewall-sort-menu');
    var viewallList = document.getElementById('ccc-viewall-list');
    if (viewallOpenBtn && viewallOverlay) {
      function collectProjects() {
        return Array.prototype.map.call(cards, function (card) {
          var img = card.querySelector('.ccc-car-card__photo img');
          var modelEl = card.querySelector('.ccc-car-card__model');
          var instaEl = card.querySelector('.ccc-car-card__insta');
          return {
            carId: card.getAttribute('data-car-id'),
            submitted: card.getAttribute('data-submitted') || '',
            photo: img ? img.getAttribute('src') : '',
            model: modelEl ? modelEl.textContent.trim() : '',
            instaText: instaEl ? instaEl.textContent.trim() : '',
            instaHref: instaEl ? instaEl.getAttribute('href') : '#'
          };
        });
      }
      var allProjects = collectProjects();
      var currentSort = 'random';
      var randomOrder = [];
      function shuffleRandomOrder() {
        randomOrder = allProjects.map(function (p) { return p.carId; });
        for (var ri = randomOrder.length - 1; ri > 0; ri--) {
          var rj = Math.floor(Math.random() * (ri + 1));
          var rt = randomOrder[ri]; randomOrder[ri] = randomOrder[rj]; randomOrder[rj] = rt;
        }
      }
      shuffleRandomOrder();
      function fetchVotesToday(cb) {
        if (!WORKER_URL || WORKER_URL.indexOf('COLE_AQUI') !== -1) { cb({}); return; }
        fetch(WORKER_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'text/plain;charset=utf-8' },
          body: JSON.stringify({ action: 'stats' })
        })
          .then(function (r) { return r.json(); })
          .then(function (res) { cb((res && res.counts) || {}); })
          .catch(function () { cb({}); });
      }
      function paintList(list) {
        viewallList.innerHTML = '';
        if (!list.length) {
          var empty = document.createElement('div');
          empty.className = 'ccc-viewall-empty';
          empty.textContent = 'Nenhum projeto encontrado';
          viewallList.appendChild(empty);
          return;
        }
        list.forEach(function (p) {
          var item = document.createElement('div');
          item.className = 'ccc-viewall-item';
          item.innerHTML =
            '<div class="ccc-viewall-item__photo" data-photo="' + p.photo + '" data-alt="' + p.model + '"><img src="' + p.photo + '" alt="' + p.model + '"></div>' +
            '<div class="ccc-viewall-item__info">' +
            '<span class="ccc-viewall-item__model">' + p.model + '</span>' +
            '<a class="ccc-viewall-item__insta" href="' + p.instaHref + '" target="_blank" rel="noopener">' + p.instaText + '</a>' +
            '</div>' +
            '<button type="button" class="ccc-viewall-item__like" data-car-id="' + p.carId + '" aria-label="Curtir">' + FIRE_SVG + '</button>';
          viewallList.appendChild(item);
        });
        viewallList.querySelectorAll('.ccc-viewall-item__photo').forEach(function (photoEl) {
          photoEl.addEventListener('click', function () {
            openLightbox(photoEl.getAttribute('data-photo'), photoEl.getAttribute('data-alt'));
          });
        });
        var currentVotes = getVotes();
        viewallList.querySelectorAll('.ccc-viewall-item__like').forEach(function (likeBtn) {
          var carId = likeBtn.getAttribute('data-car-id');
          if (currentVotes[carId]) {
            likeBtn.classList.add('is-locked');
            likeBtn.setAttribute('disabled', 'disabled');
          }
          likeBtn.addEventListener('click', function (e) {
            e.stopPropagation();
            if (likeBtn.classList.contains('is-locked')) return;
            likeBtn.classList.add('is-locked');
            likeBtn.setAttribute('disabled', 'disabled');
            saveVote(carId);
            launchBigFire();
            var proj = allProjects.filter(function (p2) { return p2.carId === carId; })[0];
            sendVote(carId, proj ? proj.model : carId);
            var carouselBtn = document.querySelector('.ccc-car-card[data-car-id="' + carId + '"] .ccc-car-card__like');
            if (carouselBtn) lockButton(carouselBtn);
          });
        });
      }
      function renderViewall() {
        var term = (viewallSearch.value || '').trim().toLowerCase();
        var filtered = allProjects.filter(function (p) {
          if (!term) return true;
          return p.model.toLowerCase().indexOf(term) !== -1 || p.instaText.toLowerCase().indexOf(term) !== -1;
        });
        if (currentSort === 'random') {
          var order = randomOrder;
          paintList(filtered.slice().sort(function (a, b) { return order.indexOf(a.carId) - order.indexOf(b.carId); }));
        } else if (currentSort === 'newest') {
          paintList(filtered.slice().sort(function (a, b) { return (b.submitted || '').localeCompare(a.submitted || ''); }));
        } else if (currentSort === 'oldest') {
          paintList(filtered.slice().sort(function (a, b) { return (a.submitted || '').localeCompare(b.submitted || ''); }));
        } else if (currentSort === 'votes-today') {
          fetchVotesToday(function (counts) {
            paintList(filtered.slice().sort(function (a, b) { return (counts[b.carId] || 0) - (counts[a.carId] || 0); }));
          });
        }
      }
      function openViewall() {
        viewallOverlay.classList.add('is-open');
        document.body.style.overflow = 'hidden';
        renderViewall();
      }
      function closeViewall() {
        viewallOverlay.classList.remove('is-open');
        document.body.style.overflow = '';
        viewallSortMenu.classList.remove('is-open');
      }
      viewallOpenBtn.addEventListener('click', openViewall);
      viewallCloseBtn.addEventListener('click', closeViewall);
      viewallOverlay.addEventListener('click', function (e) { if (e.target === viewallOverlay) closeViewall(); });
      viewallSearch.addEventListener('input', renderViewall);
      viewallSortBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        viewallSortMenu.classList.toggle('is-open');
      });
      document.addEventListener('click', function () { viewallSortMenu.classList.remove('is-open'); });
      viewallSortMenu.querySelectorAll('button').forEach(function (b) {
        b.addEventListener('click', function (e) {
          e.stopPropagation();
          currentSort = b.getAttribute('data-sort');
          if (currentSort === 'random') shuffleRandomOrder();
          viewallSortMenu.querySelectorAll('button').forEach(function (bb) { bb.classList.remove('is-active'); });
          b.classList.add('is-active');
          viewallSortMenu.classList.remove('is-open');
          renderViewall();
        });
      });
    }
  })();
  /* flip 3d dos cards da colecao */
  (function () {
    var flips = document.querySelectorAll('.ccc-flip');
    if (!flips.length) return;
    flips.forEach(function (card) {
      card.addEventListener('click', function () {
        card.classList.toggle('is-flipped');
      });
    });
  })();

  /* dropdowns dos pilares no mobile */
  (function () {
    var mq = window.matchMedia('(max-width: 820px)');
    document.querySelectorAll('.ccc-pilares__grid .ccc-card h3').forEach(function (h) {
      h.addEventListener('click', function () {
        if (!mq.matches) return;
        h.parentElement.classList.toggle('is-open');
      });
    });
  })();

/* ── ACESSO À LOJA — modal invisível, abre só com #senha no link ── */
(function () {
  var modal = document.getElementById('ccc-sa-modal');
  if (!modal) return;
  var close = document.getElementById('ccc-sa-close');
  function check() {
    if (location.hash === '#senha') modal.classList.add('is-open');
  }
  check();
  window.addEventListener('hashchange', check);
  if (close) close.addEventListener('click', function () {
    modal.classList.remove('is-open');
    if (location.hash === '#senha') history.replaceState(null, '', location.pathname + location.search);
  });
  modal.addEventListener('click', function (e) { if (e.target === modal) modal.classList.remove('is-open'); });
  /* se a senha veio errada, reabre para mostrar o erro */
  if (modal.getAttribute('data-has-errors') === 'true') modal.classList.add('is-open');
})();